const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "Téacs pras 1", answers: [], image: null },
      { id: "q2", question: "Téacs pras 2", answers: [], image: null },
      { id: "q3", question: "Téacs pras 3", answers: [], image: null },
      { id: "q4", question: "Téacs pras 4", answers: [], image: null },
      { id: "q5", question: "Téacs pras 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "irish",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: "",
  voice: "",
  versionQuestion: "Cé mhéad ceist a bheadh ​​uait sa teimpléad seo?",
};

export default openEnded;
